<app-side-menu>
  <div class="b2b-ops-page">
    <div class="page-header">
      <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
        <div>
          <button type="button" class="btn-back" (click)="navigateBack()"><i class="fas fa-arrow-left"></i></button>
          <h1 class="page-title"><i class="fas fa-file-invoice me-2"></i>Faturas</h1>
          <p class="page-subtitle" *ngIf="contractDisplayName">
            {{ contractDisplayName }}
            <span *ngIf="contractNumber"> · {{ contractNumber }}</span>
          </p>
        </div>
        <div class="d-flex gap-2 flex-wrap">
          <app-button
            text="Tabela de preços"
            color="var(--secondary-color)"
            height="40px"
            (buttonClick)="goPriceTable()">
            <i class="fas fa-tags me-2"></i>
          </app-button>
          <app-button
            *appHasPermission="'B2BContracts.Edit'"
            text="Espelho / Fechamento"
            color="var(--success-color)"
            height="40px"
            (buttonClick)="goBillingClosing()">
            <i class="fas fa-balance-scale me-2"></i>
          </app-button>
        </div>
      </div>
    </div>

    <app-b2b-operational-nav *ngIf="contractId" [contractId]="contractId" active="faturas"></app-b2b-operational-nav>

    <div class="b2b-ops-card">
      <div class="b2b-ops-filters">
        <div class="form-group">
          <label class="form-label">Ano</label>
          <input class="form-control" type="number" [(ngModel)]="filterYear" (change)="applyFilter()" placeholder="AAAA">
        </div>
        <div class="form-group">
          <label class="form-label">Mês</label>
          <input class="form-control" type="number" min="1" max="12" [(ngModel)]="filterMonth" (change)="applyFilter()" placeholder="1-12">
        </div>
        <div class="form-group">
          <label class="form-label">Categoria</label>
          <select class="form-select" [(ngModel)]="filterCategory" (change)="applyFilter()">
            <option *ngFor="let o of categoryOptions" [value]="o.value">{{ o.label }}</option>
          </select>
        </div>
        <div class="form-group">
          <label class="form-label">Status</label>
          <select class="form-select" [(ngModel)]="filterStatus" (change)="applyFilter()">
            <option *ngFor="let o of statusOptions" [value]="o.value">{{ o.label }}</option>
          </select>
        </div>
      </div>

      <div *ngIf="!isLoading && items.length === 0" class="b2b-ops-empty">
        <i class="fas fa-file-invoice"></i>
        <h3>Nenhuma fatura neste contrato</h3>
        <p>Use “Espelho / Fechamento” para gerar os rascunhos do período.</p>
      </div>

      <app-table
        *ngIf="isLoading || items.length > 0"
        [title]="'Faturas (' + items.length + ')'"
        [data]="items"
        [columns]="columns"
        [actions]="actions"
        [loading]="isLoading"
        [showSearch]="true"
        (actionClick)="onActionClick($event)">
      </app-table>
    </div>
  </div>
</app-side-menu>
